/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum CaNameEnum {
  "ICCREA" = "ICCREA",

  "NEXI" = "NEXI",

  "SIA" = "SIA"
}

// required attributes
const MessageR = t.interface({});

// optional attributes
const MessageO = t.partial({
  caName: enumType<CaNameEnum>(CaNameEnum, "caName"),

  cardsNumber: t.Integer,

  code: t.string
});

export const Message = t.intersection([MessageR, MessageO], "Message");

export type Message = t.TypeOf<typeof Message>;
